export default __webpack_public_path__ + "static/media/step2.1e2f7ba2.png";